import { checkFeature, FeatureType } from '@invivodf/front-seller-feature-flipping'

export async function usePrestaService() {
  const isPrestaServiceEnabled = await checkFeature.execute({
    id: `presta-service`,
    type: FeatureType.Dynamic,
  })

  return {
    isPrestaServiceEnabled,
  }
}
